import axiosIns from '@axiosIns'

export default {
  namespaced: true,
  state: {
    start: '',
    end: '',
    tab: 'Calls',
    isExporting: false,
  },
  getters: {
    getPeriod: state => ({ start: state.start, end: state.end }),
    getTab: state => state.tab,
    isExporting: state => state.isExporting,
  },
  mutations: {
    setStart(state, val) {
      state.start = val
    },
    setEnd(state, val) {
      state.end = val
    },
    setTab(state, val) {
      state.tab = val
    },
    setExporting(state, val) {
      state.isExporting = val
    },
  },
  actions: {
    setStartDate({ commit }, val) {
      commit('setStart', val)
    },
    setEndDate({ commit }, val) {
        commit('setEnd', val)
    },
    setTab({ commit }, val) {
      commit('setTab', val)
    },
    fetchStatisticRoute(ctx, {
        demandType,
      }) {
      const headers = {
        'Content-Type': 'application/json',
      }
      const { start, end, tab: route } = ctx.state
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`Statistics/${route}`,
            { end, start, demandType: demandType || 0 },
            {
              headers,
            })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
      async exportYoungStatistics({ commit, state }, { demandType = 0 }) {
        commit('setExporting', true)

        try {
          const headers = {
            'Content-Type': 'application/json',
          }

          const response = await axiosIns.post(
            'Statistics/ExportYoungStatistics',
            {
              start: state.start,
              end: state.end,
              demandType,
            },
            {
              headers,
              responseType: 'blob',
            },
          )

          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url

          const startDate = new Date(state.start).toISOString().split('T')[0].replace(/-/g, '')
          const endDate = new Date(state.end).toISOString().split('T')[0].replace(/-/g, '')
          link.download = `Statistiques_Jeunes_${startDate}_${endDate}.xlsx`

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)

          return { success: true }
        } catch (error) {
          console.error('Erreur lors de l\'export:', error)
          return { success: false, error }
        } finally {
          commit('setExporting', false)
        }
    },
  },
}
